import { gql, useMutation } from '@apollo/client';

import type {
  UpdateDependentPartnershipMutation,
  UpdateDependentPartnershipMutationVariables,
} from './__generated__/useUpdateDependentPartnership.gql';

const UPDATE_DEPENDENT_PARTNERSHIP = gql`
  mutation UpdateDependentPartnership($input: UpdateDependantPartnershipInput!) {
    updateDependantPartnership(input: $input) {
      id
      liveTogether
    }
  }
`;

/**
 * Updates fields on an existing `DependantPartnership` row — used by the
 * living-situation step to persist the "do they live together?" answer onto
 * the partnership the review step already created.
 *
 * Cache normalization handles the read-side update: the response carries the
 * row id + `liveTogether`, so any query selecting the same
 * `DependantPartnership:<id>` picks up the new value.
 */
export const useUpdateDependentPartnership = () => {
  return useMutation<UpdateDependentPartnershipMutation, UpdateDependentPartnershipMutationVariables>(
    UPDATE_DEPENDENT_PARTNERSHIP
  );
};
